// @flow
import type { Sample } from "../../lib/Types";
import React from "react";
import SampleEditor from "./SampleEditor";
import styled from "styled-components";
import { post } from "../../lib/Fetching";
import FixedSampleList from "./FixedSampleList";

type Props = {
  samples: Array<Sample>,
  company_id: number,
  clientView: boolean,
};

type State = {
  mode: string,
};
const HeaderText = styled.h4`
  font-size: 16pt;
`;

export default class EditingExistingSamples extends React.Component<Prop> {
  state = {
    mode: "editing",
    isSubmitting: false,
  };

  handleSubmit = (samples: Array<Sample>, reason: string) => {
    const { company_id } = this.props;
    this.setState({ isSubmitting: true });
    return post("/registration/samples/update", {
      company_id,
      samples,
      reason,
    })
      .then((json) => {
        this.setState({ mode: "viewing", isSubmitting: false });
      })
      .catch((e) => {
        this.setState({ isSubmitting: false });
        alert(e);
      });
  };

  render() {
    const { mode, isSubmitting } = this.state;
    const { company_id, samples, clientView } = this.props;
    return mode == "editing" ? (
      <div style={{ display: "table", margin: "0 auto" }}>
        <HeaderText>{I18n.t("editing_samples")}</HeaderText>
        <SampleEditor
          samples={samples}
          handleSubmit={this.handleSubmit}
          buttonTitle={I18n.t("update_samples")}
          showReason={true}
          company_id={company_id}
          isSubmitting={isSubmitting}
        />
      </div>
    ) : (
      <FixedSampleList
        company_id={company_id}
        sampleIds={samples.map((s) => s.id)}
        marginTop={0}
        clientView={clientView}
        showAttributes={false}
      />
    );
  }
}
